/* eslint-disable no-console */
import React, { useState, useContext, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import './style.css';
import { useSelector } from 'react-redux';
import { LanguageContext } from '../../../../libs/Context';
import CardViewShimmer from '../../../../components/Common/Shimmer/MediaKitShimmer/CardViewShimmer';
import { getFolder } from '../../../actions/media_actions';
import { roleCondition } from '../../../../libs/HelperContent';

const SelectTemplate = (props) =>
{
	const { handlePopup, popups, from, data, clickedUser } = props;
	const { language } = useContext(LanguageContext);
	const [ loading, setLoading ] = useState({});
	const [ listData, setListData ] = useState<any>([]);
	const location = useLocation();
	const parentData = location.state?.parentData ?? {};
	const navigate = useNavigate();
	const userData = useSelector((state:any) => state.mysession.session);
	const folderId = useParams()?.id || '';
	let folderPromise:any = '';

	const handleClose = () =>
	{
		handlePopup({ customize: false });
	};

	const handleImageLoad = (imageKey) =>
	{
		setLoading((prev) => ({ ...prev, [imageKey]: false }));
	};

	const Portrait = {
		p1 : '/images/MediakitTemplates/temp1.svg',
		p2 : '/images/MediakitTemplates/temp2.svg',
		p3 : '/images/MediakitTemplates/temp3.svg',
		p4 : '/images/MediakitTemplates/temp4.svg'
	};

	const General = {
		g1 : '/images/MediakitTemplates/General_temp1.svg',
		g2 : '/images/MediakitTemplates/General_temp2.svg',
		p1 : '/images/MediakitTemplates/General_temp3.svg',
		p2 : '/images/MediakitTemplates/General_temp4.svg'
	};

	const landscape = {
		g1 : '/images/MediakitTemplates/landscape_temp1.svg',
		g2 : '/images/MediakitTemplates/landscape_temp2.svg'
	};

	useEffect(() =>
	{
		// Initialize loading state for all images
		const allImages = { ...Portrait, ...General, ...landscape };
		const initialLoadingState = Object.keys(allImages).reduce((acc, key) =>
		{
			acc[key] = true;

			return acc;
		}, {});

		setLoading(initialLoadingState);
	}, []);

	const handleCardClick = (index, type) =>
	{
		if (from === 'edit')
		{
			navigate(`/drive/edit/${type}/${index}/${window.btoa(data?.media?.key)}`, { state: { parentData, fileData: data } });
		}
		else
		{
			navigate(`/drive/edit/${type}/${index}`);
		}
	};

	const handleImageClick = (each) =>
	{
		navigate(each?.folderId ? `/drive/design/custom/${each.folderId}/customEdit` : '/drive/design/custom/edit');
	};

	const renderImageWithLoader = (src, alt, imageKey, onClick) => (
		<div className='imageContainer'>
			{loading[imageKey] && <CardViewShimmer />}
			<button
				tabIndex={0}
				onClick={onClick}
				onKeyUp={(e) => e.key === 'Enter' && onClick()}
				className={`flexInline brdrRadiusXSM fullWidth fullHeight positionRelative selectPortrCardWidth ${imageKey === 'custom' ? 'brdr16grey' : ''}`}
			>
				<img
					src={src}
					alt={alt}
					style={{ display: loading[imageKey] ? 'none' : 'block' }}
					onLoad={() => handleImageLoad(imageKey)}
				/>
			</button>
		</div>
	);

	const getTemplatesData = async () =>
	{
		setLoading(true);
		const query: any = {
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role,
			id      : data?.folderId
		};

		if (folderId !== '')
		{
			query.id = folderId;
		}
		if (clickedUser !== '')
		{
			query.userId = clickedUser;
		}

		try
		{
			folderPromise = getFolder(query, 'getTemplates');

			const res = await folderPromise;

			if (res?.status)
			{
				setListData(res?.data);
				setLoading(false);
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.log(err);
			setLoading(false);
		}
	};

	useEffect(() =>
	{
		getTemplatesData();
	}, []);

	return (
		<Dialog
			open={popups}
			onClose={handleClose}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			maxWidth='xl'
		>
			<DialogTitle id='alert-dialog-title'>
				<div className='flexRow'>
					<div className='flexMinWidthRow pdngHXS'>
						<span className='mainHdngTxt'>{language?.selectTemp}</span>
					</div>
					<div className='flexAutoRow'>
						<button
							tabIndex={0}
							onKeyUp={(e) =>
							{
								e.key === 'Enter' && handleClose();
							}}
							className='lightTxt pointer'
							onClick={handleClose}
						>
							<CloseIcon />
						</button>
					</div>
				</div>
			</DialogTitle>
			<DialogContent>
				<div className='flexRow pdngXS'>
					<span className='subHeadingSM'>{language?.Portrait} <span className=' subHeadingXS lightTxt'> ({language?.SupWhatsappInsta})</span></span>
				</div>
				<div className='flexWrap positionRelative gap16'>
					{Object.entries(Portrait).map(([ key, src ]) => (
						<div key={key} className='flexInline pdngXS pointer mediaImgWidth'>
							{renderImageWithLoader(src, `Portrait-${key}`, key, () => handleCardClick(key, 'portrait'))}
						</div>
					))}
				</div>
				<div className='flexRow pdngXS'>
					<span className='subHeadingSM'>{language?.General} <span className='subHeadingXS lightTxt'> ({language?.SuppallSocedPltfrms})</span></span>
				</div>
				<div className='flexWrap positionRelative gap16'>
					{Object.entries(General).map(([ key, src ]) => (
						<div key={key} className='flexInline pdngXS pointer mediaImgWidth'>
							{renderImageWithLoader(src, `general-${key}`, key, () => handleCardClick(key, 'general'))}
						</div>
					))}
				</div>
				<div className='flexRow pdngXS'>
					<span className='subHeadingSM'>{language?.Landscape} <span className='subHeadingXS lightTxt'> ({language?.SupFbLinkedIn})</span></span>
				</div>
				<div className='flexWrap positionRelative gap16'>
					{Object.entries(landscape).map(([ key, src ]) => (
						<div key={key} className='flexInline pdngXS pointer mediaImgWidth'>
							{renderImageWithLoader(src, `landscape-${key}`, key, () => handleCardClick(key, 'landscape'))}
						</div>
					))}
				</div>
				{roleCondition(userData?.empRole) &&
				<>
					<div className='flexRow pdngTSM'>
						<span className='pdngXS subHeadingSM'>{language?.customTemp}</span>
					</div>
					<div className='flexWrap positionRelative gap16'>
						<div className='flexInline pdngXS pointer mediaImgWidth'>
							{renderImageWithLoader('/images/MediakitTemplates/blank_temp.svg', 'Blank Template', 'blank', handleImageClick)}
						</div>
						{
							listData?.length > 0 &&
							listData?.map((each, index) => (
								<div className='flexInline pdngXS pointer mediaImgWidth' key={each?.folderId}>

									{renderImageWithLoader(`${each?.media?.url ?? '/images/MediakitTemplates/custom_temp1.svg'}`, 'Custom Template', 'custom', () => handleImageClick(each))}
								</div>
							))
							// : <div className='flexInline pdngXS pointer mediaImgWidth'> 
							// //removed the default custom template

							// 	{renderImageWithLoader(`${'/images/MediakitTemplates/custom_temp1.svg'}`,
							//  'Custom Template', 'custom', () => {})}
							// </div> 
						}
					</div>
				</>
				}
			</DialogContent>
		</Dialog>
	);
};

export default SelectTemplate;
